<template>
  <div class="sv sv002">
    <div class="container">
      <breadcrumb-group :items="breadcrumbItems"/>

      <heading-one>au PAY スマートローンの特徴</heading-one>

      <section>
        <div class="main-box">
          <div class="txt-box">
            <p class="txt01">スマートフォン・パソコンでかんたんWEB完結！<br class="-spnone">
              au IDをお持ちの方であれば、スマートにおトクに<br class="-spnone">ご利用いただけるサービスです。</p>
          </div>
          <div class="img-box">
            <img src="@/assets/images/sv/sv002/img01.png" class="img-fluid" alt="">
          </div>
        </div>
      </section>
    </div>

    <section>
      <div class="bg-box">
        <div class="container">
          <heading-two>au PAY スマートローンとは？</heading-two>

          <div class="card-box">
            <div class="card _mr-md-40">
              <div class="card-img -center">
                <img src="@/assets/images/sv/sv002/img02.png" class="img-fluid" alt="">
              </div>
              <div class="card-body">
                <h4 class="card-title">安心、納得のお借り入れ条件</h4>
                <p class="card-text">ご利用限度額は最大100万円までなので、使いすぎなくて安心です。</p>
                <div class="card-bg">
                  <p class="txt01">ご利用限度額&nbsp;&nbsp;&nbsp;<br class="-pcnone"><span>1万円 〜 100万円</span>（要審査）</p>
                </div>
                <div class="card-bg">
                  <p class="txt01">お借り入れ利率（実質年率）&nbsp;&nbsp;&nbsp;<br class="-pcnone"><span>2.9% ～ 18.0%</span></p>
                </div>
              </div>
              <list-group class="-note">
                <list-item class="-note">実際のご契約条件は、お申し込み後の審査に基づきご提示させていただきます。</list-item>
              </list-group>
              <div class="_textright">
                <btn-text routerName="sv022" class="-next">お利息のご案内について</btn-text>
              </div>
            </div>

            <div class="card _ml-md-40" name="section_01" id="section_01">
              <div class="card-img">
                <img src="@/assets/images/sv/sv002/img03.jpg" class="img-fluid -spnone" alt="">
                <img src="@/assets/images/sv/sv002/img03_sp.png" class="img-fluid -pcnone" alt="">
              </div>
              <div class="card-body">
                <h4 class="card-title">お申し込み時の入力項目が少なく<br>かんたんにお申し込み！</h4>
                <p class="card-text">au IDに登録されているお客さま情報が自動で反映されるため、少ない項目でスマートにお申し込みができます。</p>
              </div>
            </div>
          </div>

          <div class="card-box">
            <div class="card _mr-md-40" id="section_02" name="section_02">
              <div class="card-img">
                <img src="@/assets/images/sv/sv002/img04.jpg" class="img-fluid -spnone" alt="">
                <img src="@/assets/images/sv/sv002/img04_sp.png" class="img-fluid -pcnone" alt="">
              </div>
              <div class="card-body">
                <h4 class="card-title">カードレスでご利用はすべてスマートフォンで完結！</h4>
                <p class="card-text">スマートフォン・パソコンで24時間365日お申し込みが可能です。また、新規お申し込みの際に、インターネットで口座のご登録を完了いただくとご本人さま確認書類のご提出が不要となります。</p>
              </div>
              <list-group class="-note">
                <list-item class="-note">ご本人さま確認書類をご提出のうえお申し込みいただいた場合、ご契約に必要な「確認コード」が記載されたハガキを、ご登録いただいたご住所あてに郵送します。</list-item>
              </list-group>
              <div class="_textright">
                <btn-text routerName="sv045" class="-next">お申し込み条件・お手続きの流れについて</btn-text>
              </div>
            </div>

            <div class="card _ml-md-40" id="section_04" name="section_04">
              <div class="card-img">
                <img src="@/assets/images/sv/sv002/img05.jpg" class="img-fluid -spnone" alt="">
                <img src="@/assets/images/sv/sv002/img05_sp.png" class="img-fluid -pcnone" alt="">
              </div>
              <div class="card-body">
                <h4 class="card-title">セブン銀行スマホATMで<br>いつでもお借り入れ、ご返済が可能</h4>
                <p class="card-text">au PAY スマートローンアプリをインストールすると、全国のセブン銀行スマホATMでカードレスでのお借り入れ、ご返済ができます。</p>
              </div>
              <list-group class="-note">
                <list-item class="-note">システムメンテナンスなどでご利用いただけない場合がございます。</list-item>
              </list-group>
              <div class="_textright">
                <btn-text routerName="sv025" class="-next">セブン銀行スマホATMについて</btn-text>
              </div>
              <div class="_textright">
                <btn-text routerName="sv059" class="-next">会員さま専用サイト・専用アプリについて</btn-text>
              </div>
            </div>
          </div>

          <template v-if="isWebView()">
            <btngroup-single class="_pb-md-100 _pb-sm-50">
              <btn-main class="-main" href="/entry/agreement">
                新規お申し込みはこちらから
              </btn-main>
            </btngroup-single>
          </template>
          <template v-else>
            <btngroup-single class="_pb-md-100 _pb-sm-50">
              <btn-main class="-main" routerName="en001">
                新規お申し込みはこちらから
              </btn-main>
            </btngroup-single>
          </template>
        </div>
        <p class="txt02">さらに!!</p>
      </div>
    </section>

    <section>
      <div class="container">
        <heading-two>au PAY 残高にチャージすれば<br>どこでもおトクに利用できる！</heading-two>
        <div class="au-wallet-box">
          <div class="card _ml-md-40" id="section_03" name="section_03">
            <div class="card-img">
              <img src="@/assets/images/sv/sv002/img08.gif" class="img-fluid" alt="">
            </div>
            <div class="card-body">
              <h4 class="card-title">au PAY 残高にかんたんにチャージができる！</h4>
              <p class="card-text">スマートフォンがあればどこにいても借り入れが可能です！通勤途中やお昼休みなどのちょっとした時間でお手続きが完了します。</p>
              <list-group class="-note">
                <list-item class="-note">システムメンテナンスでご利用いただけない場合がございます。</list-item>
              </list-group>
            </div>
          </div>
        </div>

        <div class="au-wallet-box">
          <div class="card _ml-md-40">
            <div class="card-img">
              <img src="@/assets/images/sv/sv001/img06.gif" class="img-fluid" alt="">
            </div>
            <div class="card-body">
              <h4 class="card-title">チャージした残高はau PAY プリペイドカードやau PAYでいろいろなお店で使える！</h4>
              <p class="card-text">全国のコンビニ・スーパーやMastercard®加盟店、au PAY加盟店などいろいろな場所で使えます。</p>
            </div>
          </div>
        </div>
        <div class="au-wallet-box _mb-md-120 _mb-sm-60">
          <div class="card _ml-md-40">
            <div class="card-img">
              <img src="@/assets/images/sv/sv001/img07.gif" class="img-fluid" alt="">
            </div>
            <div class="card-body">
              <h4 class="card-title">au PAY プリペイドカードやau PAYで使えばPontaポイントがたまる！</h4>
              <p class="card-text">ご利用額200円（税込）ごとに1Pontaポイントがたまります。</p>
              <div class="_textright">
                <btn-text routerName="sv024" class="-next">au PAY 残高へのチャージ（お借り入れ）について</btn-text>
              </div>

            </div>
          </div>
        </div>

        <cv-box class="_mb-md-120 _mb-sm-60"/>

        <contact-box class="_mb-md-120 _mb-sm-60"/>

      </div>
    </section>

  </div>
</template>

<script>

import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtnText from '../components/button/BtnText'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import CvBox from '../components/box/CvBox'
import ContactBox from '../components/box/ContactBox'
import { isWebView } from '../utils/UserAgent'
export default {
  name: 'Sv-002',
  metaInfo: {
    title: 'au PAY スマートローンの特徴',
    meta: [
      {name: 'description', content: 'au PAY スマートローンのご利用限度額や金利などのサービスの特徴を分かりやすくご紹介します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,特徴'}
    ]
  },
  components: {
    ContactBox,
    CvBox,
    BtnMain,
    BtngroupSingle,
    BtnText,
    ListItem,
    ListGroup,
    HeadingTwo,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'au PAY スマートローンの特徴',
        active: true
      }]
    }
  },
  mounted () {
    setTimeout(this.scrolleToHash, 300)
  },
  methods: {
    scrolleToHash () {
      if (this.$route.hash.match(/^#/)) {
        let id = this.$route.hash.replace(/^#/, '')
        let element = document.getElementById(id)
        let offset = isWebView() ? -10 : -70
        this.$scrollTo(element, 400, {easing: 'ease', offset: offset})
      }
    },
    isWebView: function () {
      return isWebView()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .-underline {
    &:hover {
      text-decoration: underline;
    }
    img {
      width: 8px;
    }
  }

  .main-box {
    margin-bottom: -34px;
    @include mq-up(md) {
      display: flex;
      align-items: center;
    }
    >.txt-box {
      @include mq-up(md) {
        width: 54%;
      }
      .txt01 {
        font-size: 16px;
        line-height: 24px;
        @include mq-down(md) {
          margin-bottom: 40px;
        }
        @include mq-up(md) {
          font-size: 24px;
          line-height: 36px;
          padding-left: 38px;
        }
      }
    }
    >.img-box {
      z-index: 2;
      position: relative;
      @include mq-up(md) {
        width: 46%;
      }
      @include mq-down(md) {
        padding-left: 10%;
        padding-right: 10%;
      }
    }
  }

  .bg-box {
    position:relative;
    padding-top: 20px;
    background-color: $success;
    z-index: 0;
    margin-bottom: 60px;
    @include mq-up(md) {
      padding-top: 90px;
      margin-bottom: 140px;
    }
    .card-box {
      @include mq-up(md) {
        @include flex(flex,space-between,flex-start,row,nowrap);
        margin-bottom: 50px;
      }
      >.card {
        @include mq-up(md) {
          max-width: 50%;
        }
        @include mq-down(md) {
          margin-bottom: 40px;
        }
        .card-img {
          @include mq-down(md) {
            width: 70%;
            margin: 0 auto;
          }
          img {
            @include mq-up(md) {
              max-width: 560px;
              width: 100%;
            }
            @include mq-down(md) {
              margin-bottom: 20px;
            }
          }
          &.-center {
            text-align: center;
            img {
              @include mq-up(md) {
                width: 47%;
              }
            }
          }
        }
        >.card-body {
          >.card-title {
            text-align: center;
            font-size: 18px;
            line-height: 26px;
            display: flex;
            justify-content: center;
            align-items: center;
            @include mq-down(md) {
              margin-bottom: 10px;
            }
            @include mq-up(md) {
              font-size: 24px;
              line-height: 36px;
              min-height: 90px;
            }
          }
          >.card-text {
            @include mq-up(md) {
              padding-left: 10px;
              padding-right: 10px;
            }
          }
          >.card-bg {
            background-color: #fff;
            >.txt01 {
              padding-top: 10px;
              padding-bottom: 10px;
              text-align: center;
              span {
                color: $primary;
                font-size: 20px;
                line-height: 24px;
              }
            }
          }
        }
        .icon-box {
          >.icon {
            width: 8px;
            margin-bottom: 4px;
          }
        }
        @include mq-up(md) {
          &#section_01, &#section_02, &#section_04 {
            margin-top: -50px;
            padding-top: 50px;
          }
        }
      }
    }
    .txt02 {
      font-size: 16px;
      line-height: 14px;
      color: $primary;
      font-weight: bold;
      position: absolute;
      text-align: center;
      left: 0;
      right: 0;
      z-index: 1;
      bottom: -30px;
      @include mq-up(md) {
        font-size: 32px;
        line-height: 28px;
        bottom: -50px;
      }
    }
  }
  .bg-box:after{
    border: solid transparent;
    content:'';
    height:0;
    width:0;
    pointer-events:none;
    position:absolute;
    border-color: rgba(255, 246, 232, 0);
    border-top-width:40px;
    border-bottom-width:40px;
    border-left-width:110px;
    border-right-width:110px;
    margin-left: -110px;
    border-top-color:#FFF6E8;
    top:100%;
    left:50%;
    @include mq-up(md) {
      border-top-width:80px;
      border-bottom-width:80px;
      border-left-width:210px;
      border-right-width:210px;
      margin-left: -210px;
    }
  }

  .au-wallet-box {
    >.card {
      @include mq-up(md) {
        display: flex;
      }
      img {
        margin-bottom: 20px;
        @include mq-up(md) {
          margin-bottom: 30px;
        }
      }
      >.card-img {
        width: 70%;
        @include mq-down(md) {
          margin: 0 auto;
        }
        @include mq-up(md) {
        width: 18%;
        }
      }
      >.card-body {
        @include mq-up(md) {
          width: 77%;
          padding-top: 20px;
          margin-left: 5%;
        }
        >.card-title {
          font-size: 18px;
          line-height: 26px;
          color: $primary;
          font-weight: bold;
          margin-bottom: 20px;
          @include mq-down(md) {
            text-align: center;
          }
          @include mq-up(md) {
            font-size: 24px;
            line-height: 36px;
          }
        }
        >.card-text {
          padding-left: 10px;
          padding-right: 10px;
        }
        >.card-bg {
          background-color: #fff;
          >.txt01 {
            padding-top: 10px;
            padding-bottom: 10px;
            text-align: center;
            span {
              color: $primary;
              font-size: 20px;
              line-height: 24px;
            }
          }
        }
      }
      .icon-box {
        >.icon {
          width: 8px;
          margin-bottom: 4px;
        }
      }
      @include mq-up(md) {
        &#section_03 {
          margin-top: -50px;
          padding-top: 50px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Sv002.vue